// import { theme } from "./variables.theme";
// import type { DefaultTheme } from 'styled-components';
import { T_ThemeConfig } from "@/types/theme.type";
import theme from "../assets/styles/variables/index.scss";

/**
 * Responsive support
 * Example below:
 * 
 * overlay: {
 *  padding: theme?.spacing ? theme?.spacing["5"] : "5rem",
 *  xs: {
 *      padding: theme?.spacing ? theme?.spacing["1"] : "1rem"
 *       <more css properties you can add here...>
 *  },
 *  sm: {
 *      padding: theme?.spacing ? theme?.spacing["2"] : "2rem"
 *       <more css properties you can add here...>
 *  },
 *  md: {
 *      padding: theme?.spacing ? theme?.spacing["2.5"] : "2.5rem"
 *       <more css properties you can add here...>
 *  },
 *  lg: {
 *      padding: theme?.spacing ? theme?.spacing["3"] : "3rem"
 *       <more css properties you can add here...>
 *  },
 *  xl: {
 *      padding: theme?.spacing ? theme?.spacing["3.5"] : "3.5rem"
 *       <more css properties you can add here...>
 *  }
 * }
 */

/**
 * Default theme which is used in styled-components to change the styling.
 */
const DefaultTheme: T_ThemeConfig = {
    /**
    * Not in use for now
    */
    screens: theme?.screens,

    /**
     * Custom font-faces
     */
    fontFaces: [
        {
            "@font-face": {
                "font-family": "LivelyHeadlineSemiBold",
                "src": 'local("LivelyHeadlineSemiBold"), asset-url("/fonts/LivelyHeadline-Bold.ttf") format("truetype")',
                "font-style": "normal",
                "font-weight": 500,
                "font-display": "swap",
                "preload": true
            }
        },
        {
            "@font-face": {
                "font-family": "NotoIKEALatinRegular",
                "src": 'local("NotoIKEALatinRegular"), asset-url("/fonts/NotoIKEALatin-Regular.ttf") format("truetype")',
                "font-style": "normal",
                "font-weight": 400,
                "font-display": "swap",
                "preload": true
            }
        }
    ],

    /**
    * Font family
    */
    fontFamily: {
        "Lively Headline Semi-Bold": "LivelyHeadLineSemiBold, sans-serif",
        "Lively Headline Bold": "LivelyHeadLineBold, sans-serif",
        "Noto IKEA Regular": "NotoIKEALatinRegular, sans-serif"
    },

    /**
     * Styling for TopNav component
     */
    nav: {
        color: theme?.colors?.dark,
        hover: { color: theme?.colors?.body, background: theme?.colors?.white },
        active: { color: theme?.colors?.body, background: theme?.colors?.white },
        // background: theme?.colors?.transparent
    },

    /**
     * Styling for Button component
     */
    button: {
        color: theme?.colors?.black,
        background: theme?.colors?.primary
    },

    /**
     * Styling for Form component
     */
    form: {
        color: theme?.colors?.black,
        background: theme?.colors?.transparent
    },

    /**
     * Styling for Section layout component
     */
    section: {
        color: theme?.colors?.black,
        background: theme?.colors?.white,
        fontFamily: theme?.fontFamily?.["Noto IKEA Regular"]
    },

    /**
     * Styling for Column layout component
     */
    column: {
        color: theme?.colors?.black,
        // background: theme?.colors?.white,
        fontFamily: theme?.fontFamily?.["Noto IKEA Regular"],
        // padding: theme?.spacing?.["1.5"]
    },

    /**
     * Styling for Row layout component
     */
    row: {
        color: theme?.colors?.black,
        background: theme?.colors?.transparent,
        fontFamily: theme?.fontFamily?.["Noto IKEA Regular"]
    },

    /**
     * Styling for Overlay layout component
     */
    overlay: {
        xs: {
            padding: theme?.spacing ? theme?.spacing["2"] : "2rem",
            margin: theme?.spacing ? theme?.spacing[0] : 0,
            h1: {
                fontSize: "30px",
                color: "#ffffff",
                lineHeight: "36px"
            },
            button: {
                padding: "7px 15px",
                fontSize: "14px"
            }
        },
        lg: {
            padding: theme?.spacing ? theme?.spacing["4"] : "4rem",
            margin: theme?.spacing ? theme?.spacing[0] : 0,
            h1: {
                fontSize: "50px",
                color: "#ffffff",
                lineHeight: "60px"
            },
            button: {
                padding: "10px 25px",
                fontSize: "20px"
            }
        },
        xl: {
            padding: theme?.spacing ? theme?.spacing["4"] : "4rem",
            margin: theme?.spacing ? theme?.spacing[0] : 0,
            h1: {
                fontSize: "8rem",
                color: "#ffffff",
                lineHeight: "8rem"
            },
            button: {
                padding: "10px 25px",
                fontSize: "20px"
            }
        },
        fontFamily: theme?.fontFamily?.["Lively Headline Bold"]
    },

    /**
     * Styling for html input element
     */
    input: {
        color: theme?.colors?.black,
        background: theme?.colors?.white,
        padding: theme?.spacing ? theme?.spacing["1.5"] : "1.5rem",
        margin: theme?.spacing ? theme?.spacing[0] : 0
    },

    /**
     * Styling for html textarea element
     */
    textarea: {
        color: theme?.colors?.black,
        background: theme?.colors?.white,
        padding: theme?.spacing ? theme?.spacing["1.5"] : "1.5rem",
        margin: theme?.spacing ? theme?.spacing[0] : 0
    },

    /**
     * Styling for html label element
     */
    label: {
        color: theme?.colors?.black,
        background: theme?.colors?.transparent,
        padding: theme?.spacing ? theme?.spacing["1.5"] : "1.5rem",
        margin: theme?.spacing ? theme?.spacing[0] : 0
    },
}

export default DefaultTheme;